import { pathWithBaseUrl } from "libs/constants/routes";

const ROUTES_CRM_AUTO_EFFECTIVE = {
  taxi: pathWithBaseUrl('autoefectivo-taxi'),
  effectovp: pathWithBaseUrl('autoefectivo'),
  bcp: pathWithBaseUrl('autoefectivo-bcp'),
  yape: pathWithBaseUrl('autoefectivo-yape'),
  lanzamiento: pathWithBaseUrl('autoefectivo-lanzamiento'),
}

export const getFirstPlanValue = (pathname: string) => {
  const firstValue: { [key: string]: string } = {
    [ROUTES_CRM_AUTO_EFFECTIVE.taxi]: 'Para tu taxi y más - 95',
    [ROUTES_CRM_AUTO_EFFECTIVE.effectovp]: 'Para tu carro y más - 75',
    [ROUTES_CRM_AUTO_EFFECTIVE.bcp]: 'Para tu carro y más - 39.90',
    [ROUTES_CRM_AUTO_EFFECTIVE.yape]: 'Para tu carro y más - 39.90',
    [ROUTES_CRM_AUTO_EFFECTIVE.lanzamiento]: 'Para tu carro y más - 39.90',
  };

  return firstValue[pathname] || 'General';
};

export const getSecondPlanValue = (pathname: string) => {
  const secondValue: { [key: string]: string } = {
    [ROUTES_CRM_AUTO_EFFECTIVE.taxi]: 'Para tu taxi - 85',
    [ROUTES_CRM_AUTO_EFFECTIVE.effectovp]: 'Para tu carro  - 65',
    [ROUTES_CRM_AUTO_EFFECTIVE.bcp]: 'Para tu carro  - 29.90',
    [ROUTES_CRM_AUTO_EFFECTIVE.yape]: 'Para tu carro - 29.90',
    [ROUTES_CRM_AUTO_EFFECTIVE.lanzamiento]: 'Para tu carro - 29.90',
  };

  return secondValue[pathname] || 'General';
};

export const getAutoefectivoPath = (pathname: string) => {
  const autoefectivoPath: { [key: string]: string } = {
    [ROUTES_CRM_AUTO_EFFECTIVE.effectovp]: '',
    [ROUTES_CRM_AUTO_EFFECTIVE.bcp]: '-bcp',
    [ROUTES_CRM_AUTO_EFFECTIVE.taxi]: '-taxi',
    [ROUTES_CRM_AUTO_EFFECTIVE.yape]: '-yape',
    [ROUTES_CRM_AUTO_EFFECTIVE.lanzamiento]: '-lanzamiento',
  };

  return autoefectivoPath[pathname] || '';
};

export const getAutoefectivoName = (pathname: string) => {
  const autoefectivoName: { [key: string]: string } = {
    [ROUTES_CRM_AUTO_EFFECTIVE.effectovp]: '',
    [ROUTES_CRM_AUTO_EFFECTIVE.bcp]: ' BCP',
    [ROUTES_CRM_AUTO_EFFECTIVE.taxi]: ' Taxi',
    [ROUTES_CRM_AUTO_EFFECTIVE.yape]: ' Yape',
    [ROUTES_CRM_AUTO_EFFECTIVE.lanzamiento]: ' Lanzamiento',
  };

  return autoefectivoName[pathname] || '';
};
